import { updateRunsheetShiftTableState } from '@/entities/gridTables/thunks/updateRunsheetShiftTableState'
import { runsheetShiftsSelectors, StopTypeEnum } from '@/entities/schedules'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

import { ordersSelectors } from '../ordersSelectors'
import { fetchRunsheetOrders } from './fetchRunsheetOrders'

type FetchOrdersByShiftsPayload = {
  shiftIds: EntityId[]
  forceRefresh?: boolean
}

export const fetchRunsheetOrdersByShifts = createAsyncThunk<void, FetchOrdersByShiftsPayload, ThunkApiContext>('orders/fetchRunsheetOrdersByShifts',
  async ({ shiftIds, forceRefresh }, { dispatch, getState }) => {
    const state = getState()
    const allRunsheetShifts = runsheetShiftsSelectors.selectAll(state)
    const relevantRunsheetShifts = allRunsheetShifts.filter((shift) => shiftIds.includes(shift.id))

    const orderIds: EntityId[] = []

    relevantRunsheetShifts.forEach((shift) => {
      if (shift.loads && shift.loads.length > 0) {
        const shiftOrderIds = shift.loads
          .flatMap(load => load.stops.map(stop => stop.stopType === StopTypeEnum.Order ? stop.orderId : undefined))
          .filter((orderId) => orderId !== undefined)
          .filter((orderId) => forceRefresh ? true : (orderId && !ordersSelectors.selectById(state, orderId)))

        orderIds.push(...(shiftOrderIds as EntityId[]))
      }
    })

    if (orderIds.length > 0) {
      await dispatch(fetchRunsheetOrders({ orderIds }))
    }

    // Update the runsheet shift tables state
    relevantRunsheetShifts.forEach(async (shift) => {
      await dispatch(updateRunsheetShiftTableState({ shiftId: shift.id }))
    })
  },
)
